import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';

const SummaryErrorDialog = ({ errorDialog, setErrorDialog }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleClose = () => {
    setErrorDialog({ open: false, title: '', message: '' });
  };

  return (
    <Dialog
      open={errorDialog.open}
      onClose={handleClose}
      aria-labelledby="error-dialog-title"
      aria-describedby="error-dialog-description"
      PaperProps={{
        sx: {
          borderRadius: 2,
          minWidth: { xs: '90%', sm: 400 }
        }
      }}
    >
      <DialogTitle 
        id="error-dialog-title"
        sx={{ 
          pb: 1,
          fontSize: '1.1rem',
          fontWeight: 600,
          color: '#d32f2f'
        }}
      >
        {errorDialog.title}
      </DialogTitle>
      <DialogContent>
        <Typography 
          id="error-dialog-description"
          sx={{ 
            fontSize: '0.95rem',
            lineHeight: 1.5,
            color: '#333'
          }}
        >
          {errorDialog.message}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button 
          onClick={handleClose}
          variant="contained"
          sx={{
            borderRadius: 1,
            textTransform: 'none',
            px: 3
          }}
        >
          확인
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SummaryErrorDialog; 